import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Col, Pagination, Row } from 'antd';
import { useState } from 'react';
import ProductCard from '../components/ProductCard';
import SearchProductCard from '../components/SearchProductCard';

export function PaginatedItems({
  data,
  itemsPerPage,
  handleShowDetails,
  isBetaSearchPage = false,
}) {
  const [itemOffset, setItemOffset] = useState(0);

  const getNextPageItems = start => {
    let collectedItems = [];
    let index = start;
    let contentCount = 0;

    while (contentCount < itemsPerPage && index < data.length) {
      const item = data[index];
      collectedItems.push(item);

      // Increment contentCount only if the item is not a group title
      if (!item.isGroupTitle) {
        contentCount++;
      }
      index++;
    }

    return collectedItems;
  };

  const currentItems = getNextPageItems(itemOffset);

  // Calculate the total number of content items (excluding group titles)
  const totalContentItems = data.filter(item => !item.isGroupTitle).length;

  const currentPage = Math.floor(itemOffset / itemsPerPage) + 1;

  // Invoked when the user requests another page (antd pages are 1-based).
  const handlePageChange = page => {
    const newOffset = ((page - 1) * itemsPerPage) % data.length;
    window.scrollTo(0, 0);
    setItemOffset(newOffset);
  };

  return (
    <>
      <Row gutter={[16, 16]} className="mb-6">
        {currentItems.map((item, index) =>
          item.isGroupTitle ? (
            <Col span={24} key={index}>
              <h2 className="mcfont uppercase font-semibold text-lg flex items-center drop-shadow-sm ">
                {item.groupTitle}
                <ChevronDownIcon
                  className="h-9 w-9 text-[#CF4500]"
                  aria-hidden="true"
                />
              </h2>
            </Col>
          ) : (
            <Col xs={24} sm={12} xl={8} xxl={6} key={index}>
              {isBetaSearchPage ? (
                <SearchProductCard
                  data={item}
                  onClick={() => handleShowDetails(item)}
                />
              ) : (
                <ProductCard
                  data={item}
                  onClick={() => handleShowDetails(item)}
                />
              )}
            </Col>
          ),
        )}
      </Row>

      <div className="mcfont mb-8 flex justify-center border-t border-gray-200 pt-5">
        <Pagination
          current={currentPage}
          total={totalContentItems}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
    </>
  );
}
